import request from "../../utils/request";
import { GroupInput, GroupView, RemoveUsersFromGroup, Result, UserGroupInput, UserGroupView } from "../../models/general";

export async function GetGroups() {
    const response = await request.get<Result<GroupView[]>>("UserGroup/GetGroups");
    return response.data;
}
export async function GetUserGroups() {
    const response = await request.get<Result<UserGroupView[]>>(`UserGroup/GetUserGroups`);
    return response.data;
}
export async function RemoveUserFromGroup(input : RemoveUsersFromGroup) {
    const response = await request.post<Result<boolean>>(`UserGroup/RemoveUsersFromGroup`, input);
    return response.data;
}
export async function AddUsersToGroup(input : UserGroupInput) {
    const response = await request.post<Result<boolean>>(`UserGroup/AddUsersToGroup`, input);
    return response.data;
}
export async function RemoveGroup(groupId: number) {
    const response = await request.post<Result<boolean>>('UserGroup/RemoveGroup', groupId, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}

export async function AddGroup(input : GroupInput) {
    const response = await request.post<Result<boolean>>(`UserGroup/AddGroup`, input);
    return response.data;
}


